import { render, staticRenderFns } from "./detailNew.vue?vue&type=template&id=b2d7a514&scoped=true"
import script from "./detailNew.vue?vue&type=script&lang=js"
export * from "./detailNew.vue?vue&type=script&lang=js"
import style0 from "./detailNew.vue?vue&type=style&index=0&id=b2d7a514&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2d7a514",
  null
  
)

export default component.exports